// src/pages/NightPass.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

axios.defaults.withCredentials = true;

export default function NightPass() {
  const [state, setState] = useState({ loading: true });
  const loc = useLocation();
  const navigate = useNavigate();

  async function tryConfirmFromQuery() {
    const sp = new URLSearchParams(loc.search);
    const tx = sp.get('transactionId');
    const oid = sp.get('orderId');
    if (!tx || !oid) return;

    try {
      const r = await axios
        .post('/api/payments/line/confirm', { transactionId: tx, orderId: oid })
        .then(r => r.data);

      if (r?.ok || r?.already) {
        const s = await axios.get('/api/member/night/status').then(r => r.data);
        setState({ loading: false, ...s });
        navigate(loc.pathname, { replace: true }); // 清掉 query
      }
    } catch {/* 忽略，照一般流程抓狀態 */}
  }

  useEffect(() => {
    (async () => {
      await tryConfirmFromQuery();
      try {
        const data = (await axios.get('/api/member/night/status')).data;
        setState({ loading: false, ...data });
      } catch {
        setState({ loading: false, error: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function buy() {
    try {
      const r = await axios.post('/api/payments/night/request').then(r => r.data);
      if (r?.already) {
        const s = await axios.get('/api/member/night/status').then(r => r.data);
        setState({ loading: false, ...s });
      } else if (r?.paymentUrl) {
        window.location.assign(r.paymentUrl);
      } else {
        alert('建立付款失敗，請稍後再試');
      }
    } catch {
      alert('目前無法建立付款');
    }
  }

  if (state.loading) return <div style={page}>載入中…</div>;

  // 可直接顯示密碼（staff / month / MORNING / 已購買）
  if (state.showNightCode && state.nightCode) {
    return (
      <div style={page}>
        <h2 style={h2}>今晚夜間通行碼</h2>
        <div style={code}>{state.nightCode}</div>
        <a href="/card" style={link}>回會員卡</a>
      </div>
    );
  }

  if (state.role === 'guest') {
    return (
      <div style={page}>
        <p>僅限會員可夜間入場</p>
        <a href="/card" style={link}>回會員卡</a>
      </div>
    );
  }

  // 年/資深：未購買 → 不論 DAY 或 NIGHT 都提供購買
  if (state.role === 'annual' && !state.bought && state.phase !== 'MORNING') {
    return (
      <div style={page}>
        <p>{state.phase === 'NIGHT'
              ? '目前為夜間時段，需要購買本日夜間方案。'
              : '目前為白天，可先預購本日夜間方案。'}</p>
        <div style={{display:'flex', gap:12, alignItems:'center', flexWrap:'wrap'}}>
          <button onClick={buy} style={btn}>以 1 元購買</button>
          {/* 若你已實作 GET /api/buy/night，可把 onClick 移除、href 改為 "/api/buy/night" */}
          <a href="#" onClick={(e)=>{ e.preventDefault(); buy(); }} style={link}>取得付款連結</a>
        </div>
        <p style={{marginTop:12, color:'#666'}}>完成付款後會自動顯示今晚密碼。</p>
      </div>
    );
  }

  // 月會員 / 員工理論上直接看碼；若還沒拿到（API 延遲），提示回卡頁查看
  if (state.role === 'month' || state.role === 'staff') {
    return (
      <div style={page}>
        <p>您的身分可直接查看密碼，請回會員卡查看。</p>
        <a href="/card" style={link}>回會員卡</a>
      </div>
    );
  }

  // MORNING（07–09）本來就可直接看；若沒拿到就提示回卡頁
  if (state.phase === 'MORNING') {
    return (
      <div style={page}>
        <p>07:00–09:00 可直接查看今晚密碼。</p>
        <a href="/card" style={link}>回會員卡</a>
      </div>
    );
  }

  // 其他情況
  return (
    <div style={page}>
      <p>尚未購買本日夜間方案。</p>
      <a href="/card" style={link}>回會員卡</a>
    </div>
  );
}

const page = { maxWidth: 480, margin: '40px auto', padding: '0 20px', fontFamily: "'PingFang TC','Microsoft JhengHei',sans-serif" };
const h2   = { fontSize: 28, margin: '12px 0' };
const code = { fontSize: 48, fontWeight: 900, letterSpacing: 2, margin: '18px 0' };
const link = { display: 'inline-block', textDecoration: 'underline', cursor:'pointer' };
const btn  = { padding: '12px 16px', border: 0, borderRadius: 12, background: '#1c1b1a', color: '#fff', fontWeight: 800 };
